// extracted by mini-css-extract-plugin
export var box = "_m-2";
export var checkboxControl = "_m-0";
export var checkboxRow = "_m-a";
export var checked = "_m-3";
export var descriptionSpacer = "_m-c";
export var disabled = "_m-4";
export var icon = "_m-8";
export var input = "_m-1";
export var labelSpacer = "_m-b";
export var large = "_m-7";
export var medium = "_m-6";
export var small = "_m-5";
export var text = "_m-9";